import { authenticatedFetch } from '../../../api/utils/request';

export default async function getDoctorUsers(setErrorMessage) {
    const onError = () => setErrorMessage('No se pueden obtener usuarios');
    return await authenticatedFetch('/doctor-user-management', onError);
}
